import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useState, useMemo } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var StencilDialogContext = /*#__PURE__*/createContext({
  hasOpenedDialog: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setHasOpenedDialog: function setHasOpenedDialog(value) {// do nothing.
  }
});
export var StencilDialogProvider = function StencilDialogProvider(_ref) {
  var children = _ref.children,
      defaultDialogState = _ref.defaultDialogState;

  var _useState = useState(defaultDialogState || false),
      _useState2 = _slicedToArray(_useState, 2),
      hasOpenedDialog = _useState2[0],
      setHasOpenedDialog = _useState2[1];

  var value = useMemo(function () {
    return {
      hasOpenedDialog: hasOpenedDialog,
      setHasOpenedDialog: setHasOpenedDialog
    };
  }, [hasOpenedDialog]);
  return ___EmotionJSX(StencilDialogContext.Provider, {
    value: value
  }, children);
};